import React from 'react';
import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../data/mock';

const FAQSection = () => {
  return (
    <section id="faq" className="py-20 bg-page">
      <div className="container mx-auto px-4 md:px-8">
        <div className="max-w-3xl mx-auto">
          {/* Section header */}
          <motion.div
            className="text-center mb-12"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="heading-1 mb-4">Preguntas frecuentes</h2>
            <p className="body-medium text-secondary">
              Respuestas a las dudas más comunes sobre mis servicios.
            </p>
          </motion.div>

          {/* FAQ Accordion */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.map((faq, index) => (
                <AccordionItem
                  key={index}
                  value={`item-${index}`}
                  className="bg-white rounded-xl shadow-sm border-0 overflow-hidden px-6"
                >
                  <AccordionTrigger className="text-left font-medium hover:no-underline py-5" style={{ color: '#232323' }}>
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="pb-5">
                    <p style={{ color: '#353535', fontSize: '0.95rem', lineHeight: '1.6' }}>
                      {faq.answer}
                    </p>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
